import { Markdown, Typography } from "@altimateai/lego";
import type { OpportunityDetailResponse } from "../types";
import { DetailCard } from "./DetailCard";

interface AgentInstructionsProps {
  data: OpportunityDetailResponse;
}

// "Agent Instructions" tab — renders the backend's pre-formatted
// `agent_instructions` markdown the user can drop into their own coding agent.
// The copy control lives on the tab bar (see OpportunityDetailPage). Shows an
// empty state until the backend populates the field.
export const AgentInstructions = ({ data }: AgentInstructionsProps) => {
  const md = data.metadata?.agent_instructions?.trim() || "";

  if (!md) {
    return (
      <DetailCard>
        <Typography variant="body" size="sm" className="al-text-gray-400">
          No agent instructions available for this opportunity yet.
        </Typography>
      </DetailCard>
    );
  }

  // The tab is already labelled "Agent Instructions", so the card renders the
  // content directly — no repeated title bar. The markdown's first heading has
  // its `al-prose` top margin zeroed (prose's own first-child reset can't reach
  // it through the react-markdown wrapper) so the content sits flush at the top.
  return (
    <DetailCard>
      <Markdown content={md} className="[&>div>*:first-child]:!al-mt-0" />
    </DetailCard>
  );
};
